import {
  ActionKitImpAction,
  actionKitImpFunction,
} from '../../../../components/ozmoit/common';
import { getMassiveAdmissionCallTemplate } from '../services';

export const getMassiveAdmissionCallTemplateAction: ActionKitImpAction<
  typeof getMassiveAdmissionCallTemplate
> = actionKitImpFunction(getMassiveAdmissionCallTemplate);
